interface Props {
    setFunction?: (value: string) => void
}

export const canPaste = () => {
    return !!navigator.clipboard?.readText
}

/**
 * paste function
 */
export async function paste({ setFunction }: Props) {
    if (!setFunction) {
        return
    }

    const value = await navigator.clipboard.readText()
    setFunction(value)
}
